import { useState, useEffect } from "react";
import { getVademecumPromise } from "./vademecumPrefetch";

export default function useVademecumLoading() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const p = getVademecumPromise();
    if (!p) return;
    p.finally(() => { if (!cancelled) setIsLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return isLoading;
}
